import { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useModal } from '@ebay/nice-modal-react';
import Stack from '@mui/material/Stack';
import { useDispatch, useSelector } from 'react-redux';

import { getLabelMessage } from '@gef-ui/localization/messages';

import { Dialog, Floating } from 'components';
import { EMPTY_VALUES } from 'constants/general';
import MODALS from 'constants/modals';
import dialog from 'features/common/dialog';
import fetch from 'features/common/fetch';
import { fetchClientById, prefillFormDataFromMainFilter } from 'features/views/clientSearch/actions';
import { dialogs } from 'features/views/clientSearch/constants';
import { getClients } from 'features/views/clientSearch/selectors';
import { clearSearch } from 'features/views/clientSearch/slice';

import Filter from './components/Filter';
import ResultsTable from './components/ResultsTable';

export const ClientSearchModalBody = ({ onSelect, formData = EMPTY_VALUES.OBJECT }) => {
	const dispatch = useDispatch();
	const clientSearchModal = useModal(MODALS.client_search);

	const clients = useSelector(getClients);
	const fetchState = useSelector(fetch.selectors.getFetchState(fetch.constants.urls.partnerList));

	useEffect(() => {
		dispatch(prefillFormDataFromMainFilter(formData));
	}, [dispatch, formData]);

	useEffect(
		() => () => {
			dispatch(clearSearch());
			dispatch(dialog.actions.clear());
		},
		[dispatch],
	);

	const handleClientSelect = useCallback(
		async (e) => {
			e.preventDefault();

			const selectedUser = clients[+e.target.dataset.clientId];
			const { body: partner } = await dispatch(
				fetchClientById(selectedUser.partnerId, { addressId: selectedUser.addressId }),
			);

			clientSearchModal.hide();
			onSelect(partner);
		},
		[dispatch, clients, onSelect, clientSearchModal],
	);

	return (
		<Stack spacing={4}>
			<Floating>
				<Dialog name={dialogs.requiredFields} mui flex>
					{getLabelMessage('common:requiredFields')}
					<ul>
						<li>{getLabelMessage('clientSearch:surnameNameBirthDate')}</li>
						<li>{getLabelMessage('clientSearch:surnameNameMunicipality')}</li>
						<li>{getLabelMessage('clientSearch:surnameNameStreet')}</li>
						<li>{getLabelMessage('clientSearch:surnameNameZipCode')}</li>
						<li>{getLabelMessage('clientSearch:businessNameBirthDate')}</li>
						<li>{getLabelMessage('clientSearch:businessNameMunicipality')}</li>
						<li>{getLabelMessage('clientSearch:businessNameStreet')}</li>
						<li>{getLabelMessage('clientSearch:businessNameZipCode')}</li>
						<li>{getLabelMessage('clientSearch:birthNumber')}</li>
						<li>{getLabelMessage('clientSearch:businessIn')}</li>
					</ul>
				</Dialog>
				<Dialog name={dialogs.invalidPersonIn} mui>
					{getLabelMessage('validation:invalidPersonIn')}
				</Dialog>
				<Dialog name={dialogs.invalidPersonInNotMatchingGivenBirthDate} mui>
					{getLabelMessage('validation:invalidPersonInNotMatchingGivenBirthDate')}
				</Dialog>
			</Floating>
			<Filter />
			<ResultsTable clients={clients} onSelect={handleClientSelect} fetchState={fetchState} />
		</Stack>
	);
};

ClientSearchModalBody.propTypes = {
	formData: PropTypes.shape({
		surname: PropTypes.string,
		name: PropTypes.string,
		birthDate: PropTypes.instanceOf(Date),
		birthNumber: PropTypes.string,
		businessIn: PropTypes.string,
		businessName: PropTypes.string,
		municipality: PropTypes.string,
		street: PropTypes.string,
		streetNo: PropTypes.string,
		zipCode: PropTypes.string,
	}),
	onSelect: PropTypes.func,
};

export default ClientSearchModalBody;
